import { Dispatch, useEffect } from 'react';
import { QueryStatus } from 'react-query';
import { Status } from '@uds/button';
import { Product } from '@uds/product';
import { AddProductToBasketArgs } from 'core/basket';
import { AddToBasketCta, BehaviorType } from 'core/ribbons/cta';
import useAddProductToBasket from 'application/actions/cta/useAddProductToBasket';
import usePostActionNavigate from 'application/actions/cta/usePostActionNavigate';

const statusMap: Record<QueryStatus, Status> = {
  idle: Status.DEFAULT,
  loading: Status.PENDING,
  success: Status.SUCCESS,
  error: Status.FAILURE,
};

interface HandleAddToBasketClick {
  product?: Product;
  behavior?: BehaviorType;
  setAddingStatus: Dispatch<any>;
  handleAnalytics: () => void;
  postAction?: {
    type: string;
    url?: string;
  };
}

export default ({ product, setAddingStatus, handleAnalytics, postAction }: HandleAddToBasketClick) => {
  const postActionNavigate = usePostActionNavigate(postAction);
  const { mutateAsync: addToBasket, status } = useAddProductToBasket({
    postActionNavigate,
    handleAnalytics,
  });

  useEffect(() => {
    let timeoutRef: ReturnType<typeof setTimeout>;
    setAddingStatus(statusMap[status]);

    if (status === 'error' || status === 'success') {
      timeoutRef = setTimeout(() => {
        setAddingStatus(Status.DEFAULT);
      }, 1000);
    }

    return () => {
      clearTimeout(timeoutRef);
    };
  }, [status, setAddingStatus]);

  return ({ behavior }: { behavior?: AddToBasketCta }) => {
    const items: Array<AddProductToBasketArgs> = [];
    items.push({
      skuId: product?.defaultSkuId ?? behavior?.productId,
      quantity: 1,
      term: behavior?.pricingTier?.term,
      paymentInterval: behavior?.pricingTier?.paymentInterval,
    });

    addToBasket(items);
  };
};
